var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-item"},[_c('div',[_c('img',{attrs:{"src":_vm.image}}),_c('span',[_vm._v(_vm._s(_vm.title))])]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }